//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import membersListInfo from "@/components/tasks/membersListInfo/membersListInfo.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQListBtn from "@/components/Generics/AQButtonsList/AQButtonsList.vue";
import { PERMISSIONS_ROLES } from "./appPermissionsRolesConst";

export default {
    name: "AppPermissionsUserGroupView",
    components: {
        membersListInfo,
        AQDialog,
        AQAvatar,
        AQListBtn
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        hasDelete: {
            type: Boolean,
            default: false
        },
        viewDetails: {
            type: Boolean,
            default: false
        },
        updateId: {
            type: String,
            default: ""
        },
        isOwner: {
            type: Boolean,
            default: false
        },
        parentDetails: {
            type: Object,
            default: () => ({})
        },
        editMode: {
            type: Boolean,
            default: true
        },
        noHover: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDelete: false,
            hover: false,
            itemPermissions: [],
            remainingItemPermissions: [],
            showRemoveConfirmation: false,
            itemToBeDeleted: null,
            defaultPermissionsRoles: PERMISSIONS_ROLES,
            hovered: null,
            hiddenBtnsFromList: ["edit", "download", "copy", "more"]
        };
    },
    computed: {
        getItemName() {
            let name = "";
            if (this.item.firstName && this.item.lastName) {
                name = `${this.item.firstName} ${this.item.lastName}`;
            } else if (this.item.name && this.item.lastName) {
                name = `${this.item.name} ${this.item.lastName}`;
            } else {
                name = this.item.name;
            }
            return name;
        },
        titleDialog() {
            return `${this.$t("appEditPermissions.remove")} ${this.getItemName}`;
        },
        getConfirmationBodyMsg() {
            let msgBody = this.$t("appEditPermissions.dialogBodyDefault");
            const { code, name } = this.parentDetails || {};
            if (code) {
                const permissionName = this.defaultPermissionsRoles.includes(code) ? this.$t(`applicationPermissions.${code}Role`) : name;
                msgBody = this.$t("appEditPermissions.dialogBody", { type: this.item.type.toLowerCase(), permissionName });
            }
            return msgBody;
        },
        hasRightToEdit() {
            return this.editMode && (this.viewDetails || this.hasDelete);
        },
        hasRightToDelete() {
            return this.editMode && this.hasDelete && this.hover;
        },
        tooltipStyle() {
            return "box-shadow: 0px 3px 6px #0000004D; background-color: #ffffff; padding:0";
        }
    },
    watch: {
        updateId(newValue) {
            if (newValue && this.item.id === newValue) {
                this.setPermissions();
            }
        }
    },
    mounted() {
        this.setPermissions();
    },
    methods: {
        setPermissions() {
            if (!this.hasDelete && this.item && this.item.permissions) {
                const getPermissions = (v) => {
                    const permissions = [];
                    const getTranslation = (el) => (
                        this.item.translatedRoles ? (this.item.translatedRoles[el] || el) : el
                    );
                    v.forEach(element => {
                        permissions.push(this.defaultPermissionsRoles.includes(element) ? element : getTranslation(element));
                    });
                    return permissions;
                };
                if (this.item.permissions.length > 3) {
                    const getNameTranslation = (v) => {
                        let roleName;
                        if (this.defaultPermissionsRoles.includes(v)) {
                            roleName = this.$t(`applicationPermissions.${v}Role`);
                        } else {
                            roleName = this.item.translatedRoles[v] || v;
                        }
                        return roleName;
                    };
                    this.itemPermissions = getPermissions(this.item.permissions.slice(0, 3));
                    this.remainingItemPermissions = this.item.permissions.slice(3).map(elem => ({ name: getNameTranslation(elem) }));
                } else {
                    this.itemPermissions = getPermissions(this.item.permissions);
                    this.remainingItemPermissions = [];
                }
            }
        },
        setImage(item) {
            return (item.avatarPath || item.avatar) ? `/identity/tenants/users/image/${item.id}/s` : null;
        },
        deleteItem(item) {
            this.itemToBeDeleted = item;
            this.showRemoveConfirmation = true;
            this.$emit("notificationIsOpen", true);
        },
        openItemDetails(item) {
            if (this.hasRightToEdit) {
                this.$emit("openDetails", item);
            }
        },
        actionRemoveUser(remove) {
            if (remove) {
                this.$emit("deleteItem", this.itemToBeDeleted);
            } else {
                this.$emit("notificationIsOpen", false);
            }
            this.showRemoveConfirmation = false;
            this.itemToBeDeleted = null;
        },
        isGroupType() {
            return this.item.type === "GROUP" || this.item.systemType === "SYSTEM" || this.item.systemType === "APPLICATION";
        },
        setUserType(user) {
            let type; let
                userMode;
            if (user.type === "USER") {
                if (!user.sourceType || user.sourceType === "AD") {
                    userMode = user.systemType;
                } else {
                    userMode = user.sourceType;
                }
            } else {
                userMode = user.type;
            }
            if (userMode === "TOAUTHUSR") {
                type = "systemExternalUser";
            } else if (userMode === "TSYS") {
                type = "systemInternalUser";
            } else {
                type = (user.sourceType === "AD" || user.realmId
                    || userMode === "TSAMLUSR" || userMode === "TOPENIDUSR") ? "externalUser" : "userPlatform";
            }
            return type;
        },
        setGroupType(group) {
            let type;
            if (group.systemType === "EXTERNAL") {
                type = "externalGroup";
            } else if (group.systemType === "SYSTEM") {
                type = "system";
            } else if (group.systemType === "PLATFORM") {
                type = "platform";
            } else if (group.systemType === "APPLICATION") {
                type = "applicationSpecific";
            }
            return type;
        }
    }
};
